module.exports = __webpack_public_path__ + "media/images/conspiracy_myths/antisemitism-ff8c3252690889633703cadc3f98914f.png";